import MatchedPhotos from './MatchedPhotos';

export default MatchedPhotos;
